<template>
  <div>
    <div class="row">
      <div class="col-md-offset-1 col-lg-offset-2 col-sm-6 col-md-5 col-lg-4">
        <input-fecha-hora
          v-model="fecha"
          :inline="true"
          class="m-auto"
        />
      </div>
      <div class="col-sm-6 col-md-5 col-lg-4">
        <div class="card">
          <div class="card-header text-center">
            {{ $I18n.t('rutas') }}
          </div>
          <div class="lista-rutas">
            <table class="table">
              <tbody>
                <tr
                  class="clickable"
                  :class="{ active: !rutaSeleccionada.id }"
                  @click="rutaSeleccionada = {}"
                >
                  <td>{{ $I18n.t('Todas') }}</td>
                </tr>
                <tr
                  v-for="ruta in rutas"
                  :key="ruta.id"
                  class="clickable"
                  :class="{ active: ruta.id === rutaSeleccionada.id }"
                  @click="rutaSeleccionada = ruta"
                >
                  <td :data-id="ruta.id">
                    {{ ruta.nombre }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="rutaSeleccionada.id" class="titulo-seccion">
      {{ rutaSeleccionada.nombre }}
    </div>
    <div v-else class="titulo-seccion">
      {{ $I18n.t('Turnos') }}
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped cifra-table cifra-table-gris">
          <thead>
            <tr>
              <th v-if="!rutaSeleccionada.id">{{ $I18n.t('ruta') }}</th>
              <th>{{ $I18n.t('Turno') }}</th>
              <th>{{ $I18n.t('monitor') }}</th>
              <th class="col-min">{{ $I18n.t('recogidos') }}/{{ $I18n.t('entregados') }}</th>
              <th class="col-min">{{ $I18n.t('ausentes') }}</th>
              <th class="col-min">{{ $I18n.t('Estado') }}</th>
              <th class="col-icon-1"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="turno in turnosVisibles" :key="turno.id">
              <td v-if="!rutaSeleccionada.id" class="col-min">
                {{ turno.ruta.nombre }}
              </td>
              <td>{{ turno.nombre }}</td>
              <td>{{ turno.nombre_monitor }}</td>
              <td class="text-center">
                <div v-if="turno.info_estado.iniciado" class="badge badge-info">
                  {{ turno.info_estado.registros_diarios_correctos }}
                </div>
              </td>
              <td class="text-center">
                <div v-if="turno.info_estado.iniciado" class="badge badge-danger">
                  {{ turno.info_estado.registros_diarios_ausentes }}
                </div>
              </td>
              <td>
                <div
                  v-if="turno.info_estado.finalizado"
                  data-toggle="tooltip"
                  :title="tooltipFinalizado(turno)"
                  class="label label-success"
                >
                  {{ $I18n.t('finalizado') }}
                </div>
                <div v-else-if="turno.info_estado.iniciado" class="label label-info">
                  {{ $I18n.t('iniciado') }}
                </div>
              </td>
              <td>
                <a :href="`/transporte/registros_diarios/paradas/${turno.id}?fecha=${fecha}`">
                  <i class="fa fa-edit"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { uniqBy } from 'lodash';
import transporte from '@/api/transporte';
import { dateToLocaleDateString, onlyISODate } from '../../../libs/dates';

export default {
  data() {
    return {
      fecha: '',
      rutas: [],
      turnos: [],
      rutaSeleccionada: {},
    };
  },
  computed: {
    turnosVisibles() {
      if (!this.rutaSeleccionada.id) {
        return this.turnos;
      }

      return this.turnos.filter((turno) => turno.ruta.id === this.rutaSeleccionada.id);
    },
  },
  watch: {
    fecha() {
      const params = {
        display: 'estado',
        fecha: this.fecha,
      };
      transporte.turnos.get({ params }).then((result) => {
        this.turnos = result.data;
        this.rutas = uniqBy(result.data.map((turno) => turno.ruta), 'id');
        this.rutaSeleccionada = {};
      });
    },
  },
  mounted() {
    // Para la carga inicial
    this.fecha = onlyISODate(new Date());
  },
  methods: {
    tooltipFinalizado(turno) {
      return this.$I18n.t(
        'registrado_usuario_fecha',
        {
          usuario: turno.info_estado.nombre_creador,
          fecha: dateToLocaleDateString(turno.info_estado.fecha_finalizacion),
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/stylesheets/cifra/vars/main.scss";

.lista-rutas {
  height: 216px;
  overflow: auto;

  tr.active td{
    background-color: $cifra-color;
    color: white;
  }
}
</style>
